export const STORAGE_KEYS = {
    localUser: 'localUserTour',
    secretKey: 'tourregularlink',
    idSiteConfianca: 47,
    idUsuarioSiteConfianca: 12,
    emailUsuarioSite: "siteconfianca@siteconfianca",
    senhaUsuarioSite: "@Site2024"
}